/**
 * Created by RaoMeng on 2019/3/13
 * Desc:出入校通知详情
 */

import React, {Component} from 'react'
import {connect} from 'react-redux';
import {Toast} from 'antd-mobile'
import {fetchGet} from "../../../utils/fetchRequest";
import {_host, API} from "../../../configs/api.config";
import moment from 'moment';
import './AccessNoticeDetail.css'

class AccessNoticeDetail extends Component {

    constructor() {
        super()

        this.state = {
            recordType: 0,
            stuName: '',
            date: '',
            time: '',
            week: '',
            pic: '',
            pic2: '',
        }
    }

    componentDidMount() {
        document.title = '出入校通知'
        this.anId = this.props.match.params.anId

        this.getInoutDetail()
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const {recordType, stuName, date, time, week, pic, pic2} = this.state

        return (
            <div className='common-flex-column' style={{background: 'white'}}>
                <div className='access-notice-top-layout'>
                    {recordType == 0 ? '' :
                        <div className={recordType == 1 ?
                            'access-notice-icon-in' : 'access-notice-icon-out'}>
                            {recordType == 1 ? '进' : '出'}
                        </div>}
                    <span className='access-notice-name'>{stuName}</span>
                </div>

                <div style={{padding: '6px 15px', background: '#f7f7f7'}}>
                    <span className='access-notice-time'>{time}</span>
                    <span className='access-notice-date'>{date}</span>
                    <span className='access-notice-date'>{week}</span>
                </div>

                <div className='access-notice-img-layout'>
                    <img className='access-notice-img'
                         src={pic}/>
                </div>

                {pic2 && <div className='access-notice-img-layout'>
                    <img className='access-notice-img'
                         src={pic2}/>
                </div>}
            </div>
        )
    }

    getInoutDetail() {
        Toast.show('', 0)

        fetchGet(API.INOUT_RECORD_DETAIL + '/' + this.anId, {})
            .then(response => {
                Toast.hide()

                if (response && response.data) {
                    let data = response.data
                    let recordDate = data.recordDate

                    let date = moment(recordDate).format('YYYY-MM-DD');
                    let time = moment(recordDate).format('HH:mm');

                    this.setState({
                        recordType: data.recordType,
                        stuName: data.recordName,
                        date: date,
                        time: time,
                        week: data.weekDays,
                        pic: data.recordFile,
                        pic2: data.recordFile2 || "",
                    })
                }
            })
            .catch(error => {
                Toast.hide()

                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
            })
    }
}


let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AccessNoticeDetail)
